<div
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen$ | async"
  class="sidenav flex flex-col"
>
  <div class="sidenav-toolbar flex-none flex items-center justify-between">
    <img [src]="imageUrl$ | async" class="select-none" />
    <!--    <img [src]="'https://seb.empirys.eu.ngrok.io/assets/img/LOGO_PREDIK360_Naming_seul_Clair_2.svg'">-->
    <!--    <h2 class="title ltr:pl-4 rtl:pr-4 select-none flex-auto">{{ 'cc' }}</h2>-->
    <button
      (click)="toggleCollapse()"
      *ngIf="showCollapsePin$ | async"
      class="w-8 h-8 -mr-2 leading-none flex-none hidden lg:block"
      mat-icon-button
      type="button"
    >
      <mat-icon *ngIf="!collapsed" [icIcon]="icRadioButtonChecked" size="14px"></mat-icon>
      <mat-icon *ngIf="collapsed" [icIcon]="icRadioButtonUnchecked" size="14px"></mat-icon>
    </button>
  </div>

  <vex-scrollbar class="flex-auto">
    <div class="sidenav-items">
      <vex-sidenav-item *ngFor="let item of items; trackBy: trackByRoute" [item]="item" [level]="0"></vex-sidenav-item>
    </div>
  </vex-scrollbar>
  <div class="sidenav-footer flex-none py-4 px-3 border-t ml-4">
    <span class="text-sm item-label footer-custom-text">Version {{ versionInfo.version }}</span>
  </div>
</div>
